import { motion } from "framer-motion";
import { Home, KeyRound, Handshake, ShieldCheck, BadgeCheck, Clock } from "lucide-react";

const services = [
    {
        id: "service-card-sale",
        icon: Home,
        title: "Sale",
        text: "Sell your property at the right market value with verified buyers and end-to-end documentation support.",
    },
    {
        id: "service-card-rent",
        icon: KeyRound,
        title: "Rent",
        text: "Quality rental options across Gurgaon — apartments, floors and commercial spaces with clear agreements.",
    },
    {
        id: "service-card-purchase",
        icon: Handshake,
        title: "Purchase",
        text: "Handpicked residential and commercial properties matched to your budget, with honest site-visit guidance.",
    },
];

const badges = [
    { id: "trust-badge-experience", icon: BadgeCheck, label: "Gurgaon Market Expertise" },
    { id: "trust-badge-deals", icon: ShieldCheck, label: "Transparent Deals" },
    { id: "trust-badge-service", icon: Clock, label: "Prompt Response" },
];

const Services = () => (
    <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
            <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-xs font-mono2 uppercase tracking-[0.3em] text-amber-400/90"
            >
                What We Do
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-50"
            >
                One consultant for every property need
            </motion.h2>

            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {services.map((s, i) => (
                    <motion.div
                        key={s.id}
                        data-testid={s.id}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: i * 0.12 }}
                        className="card-glow rounded-2xl border border-amber-500/20 bg-[#16203B] p-6 sm:p-8 hover:border-amber-500/50"
                    >
                        <div className="w-11 h-11 rounded-xl bg-amber-400/10 border border-amber-500/30 flex items-center justify-center">
                            <s.icon size={20} className="text-amber-400" />
                        </div>
                        <h3 className="font-display mt-5 text-xl sm:text-2xl font-semibold text-slate-100">
                            {s.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.text}</p>
                    </motion.div>
                ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
                {badges.map((b) => (
                    <span
                        key={b.id}
                        data-testid={b.id}
                        className="inline-flex items-center gap-2 rounded-full border border-amber-500/25 bg-[#1C2541] px-4 py-2 text-xs font-semibold text-slate-300"
                    >
                        <b.icon size={14} className="text-amber-400" /> {b.label}
                    </span>
                ))}
            </div>
        </div>
    </section>
);

export default Services;
